import _ from 'lodash';
import moment from 'moment';

export const assignedOptionsData = (claim, type) => {
  const taskName = type === 'LFN' ? 'legalFormalNotice' : 'courtApplication';
  const fullOptionsData = _.get(
    claim,
    `${taskName}TemplatePresection.options`
  );

  return fullOptionsData.reduce((previousValue, currentValue) => {
    const { id, type, selected } = currentValue;
    let optionValue = selected;

    if (type === 'multi_select') {
      optionValue = !selected ? [] : JSON.parse(selected);
    }
    return {
      ...previousValue,
      [id]: optionValue
    };
  }, 0);
};

export const assignedGroupsData = data => {
  if (!data) return null;
  const sectionsGroups = _.get(data, 'sectionsGroups', []);
  const allPossibleFields = _.get(data, 'fields', []);

  const formatValue = (value, type) => {
    if (type.includes('float')) {
      return value ? Number(value).toFixed(type.substring(5)) : value;
    }
    switch (type) {
      case 'array':
        return JSON.parse(value).join(', ');
      case 'integer':
        return value ? Number(value) : value;
      case 'date_time':
        return !value
          ? new Date()
          : moment.parseZone(value).format('YYYY-MM-DDTHH:mm:ss');
      case 'date':
        return !value ? moment(new Date()).format('YYYY-MM-DD') : value;
      default:
        return value ? value : '';
    }
  };

  const fullPaxFieldsData = allPossibleFields.map(singleFieldInfo => {
    const { value, type } = singleFieldInfo;
    return {
      ...singleFieldInfo,
      value: formatValue(value, type)
    };
  });

  const sectionsData = sectionsGroups.reduce((previousGroup, currentGroup) => {
    return {
      ...previousGroup,
      [currentGroup.name]: {
        ...currentGroup.sections.reduce((previousValue, currentValue) => {
          const { name, fields, template } = currentValue;
          return {
            ...previousValue,
            [name]: {
              sectionFields: fields,
              template
            }
          };
        }, {})
      }
    };
  }, 0);

  return { sectionsData, fullPaxFieldsData };
};



// WEBPACK FOOTER //
// ./src/component/TaskCreator/assignData.js